export const setPersonalizationData = (personalizationData)=> ({
    type: "SET_PERSONALIZATION_DATA_V2",
    payload: personalizationData
})

export const resetPersonalizationData = ()=>({
    type: "RESET_PERSONALIZATION_DATA_V2"
})